import { dbService } from './supabase.js'

let allTools = []

// Theme handling functions
function initTheme() {
    const savedTheme = localStorage.getItem('theme')
    
    if (savedTheme === 'dark') {
        document.body.classList.add('dark-mode')
        document.body.classList.remove('light-mode')
    } else if (savedTheme === 'light') {
        document.body.classList.add('light-mode')
        document.body.classList.remove('dark-mode')
    } else {
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
            document.body.classList.add('light-mode')
            document.body.classList.remove('dark-mode')
        } else {
            document.body.classList.add('dark-mode')
            document.body.classList.remove('light-mode')
        }
    }
    
    updateThemeToggleAppearance()
}

function updateThemeToggleAppearance() {
    const isDarkMode = document.body.classList.contains('dark-mode')
    const toggle = document.getElementById('themeToggle')
    if (toggle) {
        const icon = toggle.querySelector('.theme-toggle-icon')
        if (isDarkMode) {
            icon.textContent = '🌙'
            toggle.setAttribute('title', 'Switch to light mode')
        } else {
            icon.textContent = '☀️'
            toggle.setAttribute('title', 'Switch to dark mode')
        }
    }
}

function toggleTheme() {
    const isDarkMode = document.body.classList.contains('dark-mode')
    
    if (isDarkMode) {
        document.body.classList.remove('dark-mode')
        document.body.classList.add('light-mode')
        localStorage.setItem('theme', 'light')
    } else {
        document.body.classList.remove('light-mode')
        document.body.classList.add('dark-mode')
        localStorage.setItem('theme', 'dark')
    }
    
    updateThemeToggleAppearance()
}

function useSystemTheme() {
    localStorage.removeItem('theme')
    
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
        document.body.classList.add('light-mode')
        document.body.classList.remove('dark-mode')
    } else {
        document.body.classList.add('dark-mode')
        document.body.classList.remove('light-mode')
    }
    
    updateThemeToggleAppearance()
}

// Display tools
async function displayTools() {
    const toolsGrid = document.getElementById('toolsGrid')
    
    try {
        // Show loading state
        toolsGrid.innerHTML = '<div class="loader-container"><div class="loader"></div></div>'
        
        // Fetch tools from Supabase
        allTools = await dbService.getTools()
        
        // Display tools
        toolsGrid.innerHTML = allTools.map(tool => createToolCard(tool)).join('')
    } catch (error) {
        console.error('Error loading tools:', error)
        toolsGrid.innerHTML = '<p>Error loading tools. Please try again.</p>'
    }
}

// Create HTML for a tool card
function createToolCard(tool) {
    return `
        <a href="${tool.url}" target="_blank" rel="noopener noreferrer" class="tool-card-link">
            <div class="tool-card" data-id="${tool.id}">
                <div class="tool-icon">${tool.icon}</div>
                <h3>${tool.name}</h3>
                <p>${tool.description}</p>
                <div class="tool-category">${tool.category}</div>
            </div>
        </a>
    `
}

function setupViewToggle() {
    const viewButtons = document.querySelectorAll('.view-btn')
    
    viewButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            viewButtons.forEach(b => b.classList.remove('active'))
            btn.classList.add('active')
            
            const view = btn.dataset.view
            const toolsGrid = document.getElementById('toolsGrid')
            toolsGrid.className = view === 'grid' ? 'tools-grid' : 'tools-list'
        })
    })
}

function setupThemeToggle() {
    const themeToggle = document.getElementById('themeToggle')
    if (themeToggle) {
        themeToggle.addEventListener('click', toggleTheme)
    }
    
    const systemThemeButton = document.getElementById('systemThemeButton')
    if (systemThemeButton) {
        systemThemeButton.addEventListener('click', useSystemTheme)
    }
}

// Setup hover effects
function setupHoverEffects() {
    document.addEventListener('mousemove', (e) => {
        const glowEffect = document.querySelector('.glow-effect')
        if (glowEffect) {
            const x = e.clientX
            const y = e.clientY
            glowEffect.style.transform = `translate(${x - 400}px, ${y - 400}px)`
        }
    })
}

// Listen for system theme changes
function setupSystemThemeListener() {
    window.matchMedia('(prefers-color-scheme: light)').addEventListener('change', e => {
        if (!localStorage.getItem('theme')) {
            if (e.matches) {
                document.body.classList.add('light-mode')
                document.body.classList.remove('dark-mode')
            } else {
                document.body.classList.add('dark-mode')
                document.body.classList.remove('light-mode')
            }
            updateThemeToggleAppearance()
        }
    })
}

// Initialize the page
document.addEventListener('DOMContentLoaded', async () => {
    // Initialize theme
    initTheme()
    
    // Setup theme toggle
    setupThemeToggle()
    
    // Setup system theme listener
    setupSystemThemeListener()
    
    // Display tools
    await displayTools()
    
    // Setup view toggle
    setupViewToggle()
    
    // Setup hover effects
    setupHoverEffects()
})